import { withApiBase } from "./base";

import { getTelegramInitData } from "./tg";

export async function authWithTelegram() {
  const initData = getTelegramInitData();

  console.log("initData length =", initData?.length);
  console.log("initData head =", initData?.slice(0, 80));

  if (!initData) throw new Error("initData empty");

  const res = await fetch(withApiBase("/auth/telegram"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ initData }),
  });

  // 👇 добавь это для диагностики 401
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    console.log("auth status =", res.status);
    console.log("auth body =", text);
    throw new Error("Telegram auth failed");
  }

  return res.json();
}

export async function getCurrentUser(userId) {
  const res = await fetch(withApiBase("/users/me"), {
    headers: { "X-User-Id": String(userId) },
  });

  if (!res.ok) throw new Error("Cannot load current user");
  return res.json();
}